/** Distinguishes this record from anything else stored under the same add-in id. */
export const MAP_GROUP_STYLE_DATA_TYPE = "mapGroupStyles";

/**
 * The one record everybody reads.
 *
 * A fixed id rather than one per user: how a group's vehicles look on the map is a decision for
 * the fleet, not a preference — everyone is meant to see the workshop's vehicles in the same
 * colour. Only a map administrator may write it.
 */
export const MAP_GROUP_STYLE_RECORD_ID = "global::mapGroupStyles";

/** How the vehicles of one Geotab group are drawn. */
export interface MapGroupStyle {
  groupId: string;
  /** `#rrggbb`. Empty leaves the vehicles in the map's own colour. */
  color: string;
  /** An uploaded symbol, already checked over. Left out, the built-in arrow is used. */
  svg?: string;
}

export interface MapGroupStyleAddInData {
  id: string;
  dataType: typeof MAP_GROUP_STYLE_DATA_TYPE;
  /**
   * In the order they were added. A vehicle in two of these takes the first one's colour, so the
   * order is a priority and an object keyed by group id would lose it.
   */
  groups: MapGroupStyle[];
}

export function createMapGroupStyleRecord(groups: MapGroupStyle[]): MapGroupStyleAddInData {
  return {
    id: MAP_GROUP_STYLE_RECORD_ID,
    dataType: MAP_GROUP_STYLE_DATA_TYPE,
    groups,
  };
}

/** Whether a stored record is this one, since one add-in id can hold several kinds. */
export function isMapGroupStyleRecord(details: unknown): details is MapGroupStyleAddInData {
  const record = details as MapGroupStyleAddInData | null;
  return (
    !!record &&
    record.dataType === MAP_GROUP_STYLE_DATA_TYPE &&
    record.id === MAP_GROUP_STYLE_RECORD_ID &&
    Array.isArray(record.groups)
  );
}
